import { useState, useEffect } from 'react';
import { useRef } from 'react';
import {
  FiPlus, FiMessageSquare, FiTrash2, FiLogOut,
  FiHelpCircle, FiBarChart, FiMenu,
  FiGrid, FiEdit2, FiDollarSign, FiBarChart2, FiTrendingUp, FiUserCheck
} from 'react-icons/fi';
import '../Styles/Sidebar.css'
import SaviFullLogo from '../Images/SAVI AI full.png';
import SaviHalfLogo from '../Images/SAVI AI Halff.png';
import '../Styles/Chat.css'

const Sidebar = ({
  isSidebarActive,
  startNewChat,
  chatHistory,
  activeChatId,
  selectChat,
  moveToTrash,
  toggleSidebar,
  activeNavItem,
  setActiveNavItem,
  setShowFAQ,
  setShowDashboard,
  setMessages,
  setActiveDashboard,
  setDashboardUrl,
  setInputText,
  handleLogout,
  handleSwitch,
  openDropdown,
  setOpenDropdown,
  openNestedDropdown,
  setOpenNestedDropdown,
  activeDashboard,
  setActiveChatId,
  setChatHistory,
  setOverlayMenu,
  openSubmenuParent
}) => {
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [newChatTitle, setNewChatTitle] = useState('');
  const [renameAnchorEl, setRenameAnchorEl] = useState(null);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 430);
  // Navigation items
  const navItems = {
    Menu: [
      // {
      //   name: 'CRM Sales',
      //   icon: <FiUserCheck size={16} />,
      //   onClick: () => {
      //     // startNewChat();
      //     setActiveNavItem('CRM Sales');
      //     setShowFAQ(false);
      //     setShowDashboard(false);
      //     // setMessages([]);
      //   }
      // },
      // {
      //   name: 'Deals & Revenue',
      //   icon: <FiDollarSign size={16} />,
      //   onClick: () => {
      //     // startNewChat();
      //     setActiveNavItem('Deals & Revenue');
      //     setShowFAQ(false);
      //     setShowDashboard(false);
      //     // setMessages([]);
      //   }
      // },
      // {
      //   name: 'Insights & Intelligent',
      //   icon: <FiTrendingUp size={16} />,
      //   onClick: () => {
      //     // startNewChat();
      //     setActiveNavItem('Insights & Intelligent');
      //     setShowFAQ(false);
      //     setShowDashboard(false);
      //     // setMessages([]);
      //   }
      // },
      // {
      //   name: 'Chat',
      //   icon: <FiMessageSquare size={16} />,
      //   onClick: () => {
      //     setShowDashboard(false);
      //     setActiveNavItem('Chat');
      //     setShowFAQ(false);
      //     setInputText('');
      //     if (chatHistory.length > 0) {
      //       const lastChat = chatHistory[chatHistory.length - 1];
      //       selectChat(lastChat.id);
      //     }
      //     setMessages([]); // Clear messages to show WelcomeCards
      //     setActiveChatId(null);
      //   }
      // },
      // {
      //   name: 'Revenue',
      //   icon: <FiDollarSign size={16} />,
      //   onClick: () => {
      //     setActiveNavItem('Revenue');
      //     setShowDashboard(false);
      //     setShowFAQ(false);
      //     setMessages([]); // Clear chat messages
      //   }
      // },
      {
        name: 'Persona',
        icon: <FiBarChart size={16} />,
        hasDropdown: true,
        onClick: () => {
          startNewChat();
          setActiveNavItem('Persona');
          setShowDashboard(false);
          setShowFAQ(false);
          setMessages([]);
        },
        subItems: [
          {
            name: 'CEO',
            hasNestedDropdown: true,
            nestedItems: [
              {
                name: 'Customer Management',
                onClick: () => {
                  startNewChat();
                  setActiveNavItem('CEO Dashboard');
                  setActiveDashboard('Customer Management');
                  setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=5aa26da8-7573-46c0-9cab-c54a2e9a2459&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
                  setShowDashboard(true);
                  setShowFAQ(false);
                  setMessages([]);
                }
              },
              {
                name: 'Customer 360',
                onClick: () => {
                  startNewChat();
                  setActiveNavItem('CEO Dashboard');
                  setActiveDashboard('Customer 360');
                  setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=8dc7df37-876f-4c95-998f-3e5fa0ca81d5&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
                  setShowDashboard(true);
                  setShowFAQ(false);
                  setMessages([]);
                }
              }, {
                name: 'Opportunity 360',
                onClick: () => {
                  startNewChat();
                  setActiveNavItem('CEO Dashboard');
                  setActiveDashboard('Opportunity 360');
                  setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=c4f1009c-dcba-45dd-893b-c687194ed1ee&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
                  setShowDashboard(true);
                  setShowFAQ(false);
                  setMessages([]);
                }
              }, {
                name: 'Accounts 360',
                onClick: () => {
                  startNewChat();
                  setActiveNavItem('CEO Dashboard');
                  setActiveDashboard('Accounts 360');
                  setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=70b4c5ad-6ed6-427f-9a6a-e0ba23d12643&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
                  setShowDashboard(true);
                  setShowFAQ(false);
                  setMessages([]);
                }
              }
            ]
          },
          {
            name: 'CHRO',
            hasNestedDropdown: true,
            nestedItems: [
              {
                name: 'Company Overview',
                onClick: () => {
                  startNewChat();
                  setActiveNavItem('CHRO Dashboard');
                  setActiveDashboard('Company Overview');
                  setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=1dcae81a-651d-4752-9f38-ca6d20c468b7&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
                  setShowDashboard(true);
                  setShowFAQ(false);
                  setMessages([]);
                }
              },
              {
                name: 'Daily TimeSheet',
                onClick: () => {
                  startNewChat();
                  setActiveNavItem('CHRO Dashboard');
                  setActiveDashboard('Daily TimeSheet');
                  setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=71b441f3-bcc5-4738-bcfc-2e39d45e3d8c&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
                  setShowDashboard(true);
                  setShowFAQ(false);
                  setMessages([]);
                }
              },
              {
                name: 'RMO',
                onClick: () => {
                  startNewChat();
                  setActiveNavItem('CHRO Dashboard');
                  setActiveDashboard('RMO');
                  setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=73d0390c-b991-4828-a3d2-2f13794c4cc7&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
                  setShowDashboard(true);
                  setShowFAQ(false);
                  setMessages([]);
                }
              },
              {
                name: 'Timeoff',
                onClick: () => {
                  startNewChat();
                  setActiveNavItem('CHRO Dashboard');
                  setActiveDashboard('Timeoff');
                  setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=b89c78b8-814c-4989-8552-9226885ced3d&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
                  setShowDashboard(true);
                  setShowFAQ(false);
                  setMessages([]);
                }
              },
              {
                name: 'Recruiter',
                onClick: () => {
                  startNewChat();
                  setActiveNavItem('CHRO Dashboard');
                  setActiveDashboard('Recruiter');
                  setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=055d7f35-266d-472a-8a99-77c9533b8476&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
                  setShowDashboard(true);
                  setShowFAQ(false);
                  setMessages([]);
                }
              },
              {
                name: 'PMGM',
                onClick: () => {
                  startNewChat();
                  setActiveNavItem('CHRO Dashboard');
                  setActiveDashboard('PMGM');
                  setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=830b9daf-9dd5-4068-bf12-364708eab3fc&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
                  setShowDashboard(true);
                  setShowFAQ(false);
                  setMessages([]);
                }
              },
              // {
              //   name: 'Project Wice TimeSheet',
              //   onClick: () => {
              //     startNewChat();
              //     setActiveNavItem('CHRO Dashboard');
              //     setActiveDashboard('Project Wice TimeSheet');
              //     setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=e89e16d3-e4df-45d8-a013-6cbdb7ef5fc5&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
              //     setShowDashboard(true);
              //     setShowFAQ(false);
              //     setMessages([]);
              //   }
              // }
            ]
          },
          {
            name: 'CFO',
            hasNestedDropdown: true,
            nestedItems: [
              {
                name: 'Customer Aging',
                onClick: () => {
                  startNewChat();
                  setActiveNavItem('CFO Dashboard');
                  setActiveDashboard('Customer Aging');
                  setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=7d92eb38-c318-41ee-92ef-ba7b2d998a4e&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
                  setShowDashboard(true);
                  setShowFAQ(false);
                  setMessages([]);
                }
              },
              {
                name: 'Vendor Aging',
                onClick: () => {
                  startNewChat();
                  setActiveNavItem('CFO Dashboard');
                  setActiveDashboard('Vendor Aging');
                  setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=9944b5d2-e9a5-42d8-a4db-7eb07f885863&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
                  setShowDashboard(true);
                  setShowFAQ(false);
                  setMessages([]);
                }
              },
              {
                name: 'Customer Aging Details',
                onClick: () => {
                  startNewChat();
                  setActiveNavItem('CFO Dashboard');
                  setActiveDashboard('Customer Aging Details');
                  setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=437b37d3-a67f-4a6e-8804-5cafc7ed16da&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
                  setShowDashboard(true);
                  setShowFAQ(false);
                  setMessages([]);
                }
              },
              // {
              //   name: 'Target vs Actual',
              //   onClick: () => {
              //     startNewChat();
              //     setActiveNavItem('CFO Dashboard');
              //     setActiveDashboard('Target vs Actual');
              //     setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=8f94ccab-d936-4431-87ac-f2c496587ace&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
              //     setShowDashboard(true);
              //     setShowFAQ(false);
              //     setMessages([]);
              //   }
              // },
              {
                name: 'Sales',
                onClick: () => {
                  startNewChat();
                  setActiveNavItem('CFO Dashboard');
                  setActiveDashboard('Sales');
                  setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=63136864-ec70-4d7e-bd7e-6868884a9830&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
                  setShowDashboard(true);
                  setShowFAQ(false);
                  setMessages([]);
                }
              },
              {
                name: 'Customer Master Data',
                onClick: () => {
                  startNewChat();
                  setActiveNavItem('CFO Dashboard');
                  setActiveDashboard('Customer Master Data');
                  setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=91903dd4-1d7b-441a-9d90-83913e541519&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
                  setShowDashboard(true);
                  setShowFAQ(false);
                  setMessages([]);
                }
              },
              {
                name: 'Vendor Master Data',
                onClick: () => {
                  startNewChat();
                  setActiveNavItem('CFO Dashboard');
                  setActiveDashboard('Vendor Master Data');
                  setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=ede758b7-7d1b-466e-9920-df010321f81d&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
                  setShowDashboard(true);
                  setShowFAQ(false);
                  setMessages([]);
                }
              },
              {
                name: 'Revenue Rolling Plan',
                onClick: () => {
                  startNewChat();
                  setActiveNavItem('CFO Dashboard');
                  setActiveDashboard('Revenue Rolling Plan');
                  // setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=214cd590-159d-4da1-8056-8c8fb5fb39d0&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
                  setDashboardUrl('https://app.powerbi.com/view?r=eyJrIjoiNjk4YjBmN2QtNzcyMC00OGI3LWIwNDAtODExZThiMjJiNmQ4IiwidCI6IjhhNTBhMThiLWMxMzUtNGQwMi1iMjFhLWJkNmIxMTRjNjc1NSJ9');
                  setShowDashboard(true);
                  setShowFAQ(false);
                  setMessages([]);
                }
              }
            ]
          },
          {
            name: 'CSO',
            hasNestedDropdown: true,
            nestedItems: [
              {
                name: 'Customer Management',
                onClick: () => {
                  startNewChat();
                  setActiveNavItem('CEO Dashboard');
                  setActiveDashboard('Customer Management');
                  setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=5aa26da8-7573-46c0-9cab-c54a2e9a2459&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
                  setShowDashboard(true);
                  setShowFAQ(false);
                  setMessages([]);
                }
              },
              {
                name: 'Opportunity 360',
                onClick: () => {
                  startNewChat();
                  setActiveNavItem('CSO Dashboard');
                  setActiveDashboard('Opportunity 360');
                  setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=c4f1009c-dcba-45dd-893b-c687194ed1ee&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
                  setShowDashboard(true);
                  setShowFAQ(false);
                  setMessages([]);
                }
              }, {
                name: 'Accounts 360',
                onClick: () => {
                  startNewChat();
                  setActiveNavItem('CSO Dashboard');
                  setActiveDashboard('Accounts 360');
                  setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=70b4c5ad-6ed6-427f-9a6a-e0ba23d12643&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
                  setShowDashboard(true);
                  setShowFAQ(false);
                  setMessages([]);
                }
              }
            ]
          },
          {
            name: 'CDO',
            onClick: () => {
              startNewChat();
              setActiveNavItem('Analytics Dashboard');
              setActiveDashboard('CDO');
              setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=2581ab73-2284-443f-b815-93fe6e6aa525&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
              setShowDashboard(true);
              setShowFAQ(false);
              setMessages([]);
            }
          },
          {
            name: 'CMO',
            hasNestedDropdown: true,
            nestedItems: [
              {
                name: 'Customer Management',
                onClick: () => {
                  startNewChat();
                  setActiveNavItem('CEO Dashboard');
                  setActiveDashboard('Customer Management');
                  setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=5aa26da8-7573-46c0-9cab-c54a2e9a2459&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
                  setShowDashboard(true);
                  setShowFAQ(false);
                  setMessages([]);
                }
              },
              {
                name: 'Opportunity 360',
                onClick: () => {
                  startNewChat();
                  setActiveNavItem('CMO Dashboard');
                  setActiveDashboard('Opportunity 360');
                  setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=c4f1009c-dcba-45dd-893b-c687194ed1ee&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
                  setShowDashboard(true);
                  setShowFAQ(false);
                  setMessages([]);
                }
              }, {
                name: 'Accounts 360',
                onClick: () => {
                  startNewChat();
                  setActiveNavItem('CMO Dashboard');
                  setActiveDashboard('Accounts 360');
                  setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=70b4c5ad-6ed6-427f-9a6a-e0ba23d12643&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
                  setShowDashboard(true);
                  setShowFAQ(false);
                  setMessages([]);
                }
              }
            ]
          }
        ]
      },
      // {
      //   name: 'Unified Bi Hub',
      //   icon: <FiGrid size={16} />,
      //   hasDropdown: true,
      //   subItems: [
      //     {
      //       name: 'Customer 360',
      //       onClick: () => {
      //         setActiveNavItem('Unified Bi Hub');
      //         setActiveDashboard('Customer 360');
      //         setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=c07215da-df96-4e81-b281-4dec4e080fdf&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
      //         setShowDashboard(true);
      //         setShowFAQ(false);
      //         setMessages([]);
      //       }
      //     },
      //     {
      //       name: 'Opprtunity 360',
      //       onClick: () => {
      //         setActiveNavItem('Unified Bi Hub');
      //         setActiveDashboard('Opprtunity 360');
      //         setDashboardUrl('https://app.powerbi.com/reportEmbed?reportId=0e910c15-6d91-47e6-9533-c53170be1cc9&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755');
      //         setShowDashboard(true);
      //         setShowFAQ(false);
      //         setMessages([]);
      //       }
      //     },
      //     {
      //       name: 'People 360',
      //       onClick: () => {
      //         setActiveNavItem('Unified Bi Hub');
      //         setActiveDashboard('People 360');
      //         setDashboardUrl('');
      //         setShowDashboard(true);
      //         setShowFAQ(false);
      //         setMessages([]);
      //       }
      //     },
      //     {
      //       name: 'Project 360',
      //       onClick: () => {
      //         setActiveNavItem('Unified Bi Hub');
      //         setActiveDashboard('Project 360');
      //         setDashboardUrl('');
      //         setShowDashboard(true);
      //         setShowFAQ(false);
      //         setMessages([]);
      //       }
      //     }
      //   ]
      // },
      // {
      //   name: 'Agents',
      //   icon: <FiGrid size={16} />,
      //   onClick: () => {
      //     startNewChat();
      //     setActiveNavItem('Agents');
      //     setShowFAQ(false);
      //     setShowDashboard(false);
      //     setMessages([]);
      //   }
      // },
      // {
      //   name: 'InsightApps',
      //   icon: <FiTrendingUp size={16} />, // You can use a different icon if you want
      //   onClick: () => {
      //     startNewChat();
      //     setActiveNavItem('InsightApps');
      //     setShowFAQ(false);
      //     setShowDashboard(false);
      //     setMessages([]); // Clear chat messages
      //   }
      // },
      {
        name: 'FAQ',
        icon: <FiHelpCircle size={16} />,
        onClick: () => {
          startNewChat();
          setActiveNavItem('FAQ');
          setShowFAQ(true);
          setShowDashboard(false);
          setMessages([]);
        }
      }
    ]
  };

  const handleRenameClick = (event, chat) => {
    setRenameAnchorEl(event.currentTarget);
    setNewChatTitle(chat.title);
    setActiveChatId(chat.id);
  };

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 430);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleRenameClose = () => {
    setRenameAnchorEl(null);
  };

  const handleRenameConfirm = () => {
    if (newChatTitle.trim() && activeChatId) {
      const updatedHistory = chatHistory.map(c =>
        c.id === activeChatId ? { ...c, title: newChatTitle } : c
      );
      setChatHistory(updatedHistory);
    }
    handleRenameClose();
  };

  return (
    <>
      {isSidebarActive && window.innerWidth <= 426 && (
        <div
          className="sidebar-overlay"
          onClick={toggleSidebar}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            zIndex: 998,
            background: 'rgba(0, 0, 0, 0.25)', // nearly transparent, but catches clicks
          }}
        />
      )}
      <div className={`sidebar ${isSidebarActive ? 'active' : 'collapsed'}`}>
        <div className='hamburger-menu-container'>
          <div className={`hamburger-menu`} onClick={toggleSidebar}>
            <button className='menu-btn'><FiMenu size={20} /></button>
          </div>
          {!isSidebarActive && (
            <div className="logo-container1" onClick={toggleSidebar} style={{ cursor: 'pointer' }}>
              <img src={SaviHalfLogo} alt="SAVI Half Logo" style={{ width: 30, height: 30 }} />
            </div>
          )}
          <div className="logo-container2" onClick={startNewChat} style={{ cursor: 'pointer' }}>
            <img src={SaviFullLogo} alt="AV Logo" style={{ width: 53, height: 19 }} />
          </div>
        </div>

        <div className="new-chat-container">
          <button
            className="new-chat-btn"
            onClick={() => {
              startNewChat();
              if (window.innerWidth <= 426) toggleSidebar();
            }}
            title="New Chat"
          >
            <FiPlus className="plus-icon" size={18} />
            {isSidebarActive && <span>New Chat</span>}
          </button>
        </div>
        <>
          <div className="sidebar-section">
            <h3 className="section-title">Recent Chats
              <button
                className="new-chat-btn"
                onClick={() => {
                  startNewChat();
                  if (window.innerWidth <= 426) toggleSidebar();
                }}
                title="New Chat"
              >
                <FiPlus className="plus-icon" size={18} />
              </button></h3>
            <div className="recent-chats">
              {!chatHistory || chatHistory.length === 0 ? (
                <div className="no-chats-message">No recent chats</div>
              ) : (
                chatHistory.slice().reverse().slice(0, 10).map((chat) => (
                  <div
                    key={chat.id}
                    className={`recent-chat-item ${chat.id === activeChatId ? 'active current-chat' : ''}`}
                    style={{
                      cursor: chat.id === activeChatId ? 'not-allowed' : 'pointer'
                    }}
                    onClick={() => {
                      if (chat.id !== activeChatId) {
                        selectChat(chat.id);
                        setShowDashboard(false);
                      }
                    }}
                  >
                    <div className="chat-title">{chat.title}</div>
                    <div className="chat-item-actions">
                      <button
                        className="chat-action-btn"
                        onClick={(e) => handleRenameClick(e, chat)}
                        title="Rename chat"
                      >
                        <FiEdit2 size={14} />
                      </button>
                      <button
                        className="chat-action-btn"
                        onClick={(e) => moveToTrash(chat.id, e)}
                        title="Move to bin"
                      >
                        <FiTrash2 size={14} />
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>


        </>
        {/* Add collapsed bottom nav for collapsed sidebar */}
        {!isSidebarActive && (
          <div className="sidebar-collapsed-bottom">
            {/* <button
              className={`nav-btn ${activeNavItem === 'Chat' ? 'active' : ''}`}
              onClick={() => {
                if (!isSidebarActive) toggleSidebar();
                setActiveNavItem('Chat');
                setShowDashboard(false);
                setShowFAQ(false);
                setInputText('');
                if (chatHistory.length > 0) {
                  const lastChat = chatHistory[chatHistory.length - 1];
                  selectChat(lastChat.id);
                }
                else {
                  setMessages([]);
                  setActiveChatId(null);
                }
              }}
              title="Chat"
            >
              <FiMessageSquare size={16} />
            </button> */}
            {/* <button
              className={`nav-btn ${activeNavItem === 'revenue' ? 'active' : ''}`}
              onClick={() => {
                setActiveNavItem('revenue');
                setShowFAQ(false);
                setShowDashboard(false);
                setOpenDropdown('revenue');
                setOpenNestedDropdown(null);
                toggleSidebar();

              }}
              title="revenue"
            >
              <FiDollarSign size={16} />
            </button> */}
            {/* <button
              className={`nav-btn ${activeNavItem === 'Persona' ? 'active' : ''}`}
              onClick={() => {
                startNewChat();
                setActiveNavItem('Persona');
                setShowDashboard(false);
                setShowFAQ(false);
                setOpenDropdown('Persona');
                setOpenNestedDropdown(null);
                toggleSidebar(); // Open sidebar to show dropdown
              }}
              title="Persona"
            >
              <FiBarChart size={16} />
            </button> */}
            {/* <button
              className={`nav-btn ${activeNavItem === 'Unified Bi Hub' ? 'active' : ''}`}
              onClick={() => {
                setActiveNavItem('Unified Bi Hub');
                setShowFAQ(false);
                setShowDashboard(false);
                setOpenDropdown('Unified Bi Hub');
                setOpenNestedDropdown(null);
                toggleSidebar(); // Open sidebar to show dropdown
              }}
              title="Unified Bi Hub"
            >
              <FiGrid size={16} />
            </button> */}
            {/* <button
              className={`nav-btn ${activeNavItem === 'Agents' ? 'active' : ''}`}
              onClick={() => {
                startNewChat();
                setActiveNavItem('Agents');
                setShowFAQ(false);
                setShowDashboard(false);
                setMessages([]);
                toggleSidebar();
              }}
              title="Agents"
            >
              <FiGrid size={16} />
            </button> */}
            {/* <button
              className={`nav-btn ${activeNavItem === 'InsightApps' ? 'active' : ''}`}
              onClick={() => {
                startNewChat();
                setActiveNavItem('InsightApps');
                setShowFAQ(false);
                setShowDashboard(false);
                setMessages([]);
                toggleSidebar();
              }}
              title="InsightApps"
            >
              <FiTrendingUp size={16} />
            </button> */}
            {/* <button
              className={`nav-btn ${activeNavItem === 'CRM Sales' ? 'active' : ''}`}
              onClick={() => {
                // startNewChat();
                setActiveNavItem('CRM Sales');
                setShowFAQ(false);
                setShowDashboard(false);
                // setMessages([]);
                toggleSidebar();
              }}
              title="CRM Sales"
            >
              <FiUserCheck size={16} />
            </button> */}
            {/* <button
              className={`nav-btn ${activeNavItem === 'Deals & Revenue' ? 'active' : ''}`}
              onClick={() => {
                // startNewChat();
                setActiveNavItem('Deals & Revenue');
                setShowFAQ(false);
                setShowDashboard(false);
                // setMessages([]);
                toggleSidebar();
              }}
              title="Deals & Revenue"
            >
              <FiDollarSign size={16} />
            </button> */}
            {/* <button
              className={`nav-btn ${activeNavItem === 'Insights & Intelligent' ? 'active' : ''}`}
              onClick={() => {
                // startNewChat();
                setActiveNavItem('Insights & Intelligent');
                setShowFAQ(false);
                setShowDashboard(false);
                // setMessages([]);
                toggleSidebar();
              }}
              title="Insights & Intelligent"
            >
              <FiTrendingUp size={16} />
            </button> */}
            {/* <button
              className={`nav-btn ${activeNavItem === 'FAQ' ? 'active' : ''}`}
              onClick={() => {
                startNewChat();
                setActiveNavItem('FAQ');
                setShowFAQ(true);
                setShowDashboard(false);
                setMessages([]);
              }}
              title="FAQ"
            >
              <FiHelpCircle size={16} />
            </button> */}
            <button
              className="footer-btn logout-btn"
              onClick={handleLogout}
              title="Logout"
            >
              <FiLogOut size={14} />
            </button>
          </div>
        )}
        <div className="sidebar-footer">
          <button className="footer-btn logout-btn" onClick={handleLogout} title="Logout">
            <FiLogOut size={14} />
            {isSidebarActive && <span>Logout</span>}
          </button>
          {/* <button className="footer-btn switch-btn" onClick={handleSwitch} title="Switch">
          <FiRefreshCw size={14} />
          {isSidebarActive && <span>Switch</span>}
        </button> */}
        </div>
      </div>
      {renameAnchorEl && (
        <div className="rename-popup-overlay" onClick={handleRenameClose}>
          <div
            className="rename-popup"
            onClick={(e) => e.stopPropagation()

            }
          >
            <h4>Rename Chat</h4>
            <input
              type="text"
              value={newChatTitle}
              onChange={(e) => setNewChatTitle(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleRenameConfirm();
                }
              }}
              autoFocus
            />
            <div className="rename-popup-actions">
              <button onClick={handleRenameConfirm} className="confirm-btn">
                Confirm
              </button>
              <button onClick={handleRenameClose} className="cancel-btn">
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default Sidebar;
